import styled from 'styled-components';
import { Colors } from '@/common/colors/colors';

export const Products = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 8px;
	margin-top: 16px;
	width: 100%;
`;

export const ProductsTitle = styled.div`
	color: ${Colors.darkBlue};
	font-weight: bold;
`;
